export default {
  'en': {
    // short: { year: 'numeric', month: 'short', day: 'numeric'},
    alvShort: { year: 'numeric', month: 'numeric', day: 'numeric' },
    alvDateFormat: { year: 'numeric', month: '2-digit', day: '2-digit' },
    alvDateTime: { 
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    },
    alvMonthYearFormat: {
      year: 'numeric', month: 'long'
    }
    // long: {
    //   year: 'numeric', month: 'short', day: 'numeric',
    //   weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    // }
  },
  'de': {
    // short: { year: 'numeric', month: 'short', day: 'numeric' },
    alvShort: { year: 'numeric', month: 'numeric', day: 'numeric' },
    alvDateFormat: { year: 'numeric', month: '2-digit', day: '2-digit' },
    alvDateTime: { 
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    },
    alvMonthYearFormat: {
      year: 'numeric', month: 'long'
    }    
    // long: {
    //   year: 'numeric', month: 'short', day: 'numeric',
    //   weekday: 'short', hour: 'numeric', minute: 'numeric'
    // }
  },
  'ja': { 
    // short: { year: 'numeric', month: 'short', day: 'numeric' },
    alvShort: { year: 'numeric', month: 'numeric', day: 'numeric' },
    alvDateFormat: { year: 'numeric', month: '2-digit', day: '2-digit' },
    alvDateTime: { 
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    },  
    alvMonthYearFormat: {
      year: 'numeric', month: 'long'
    }  
    // long: {
    //   year: 'numeric', month: 'short', day: 'numeric',
    //   weekday: 'short', hour: 'numeric', minute: 'numeric'
    // }
  },
  'ko': { 
    // short: { year: 'numeric', month: 'short', day: 'numeric'},
    alvShort: { year: 'numeric', month: 'numeric', day: 'numeric' },
    alvDateFormat: { year: 'numeric', month: '2-digit', day: '2-digit' },
    alvDateTime: { 
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    },
    alvMonthYearFormat: {
      year: 'numeric', month: 'long'
    }
    // long: {
    //   year: 'numeric', month: 'short', day: 'numeric',
    //   weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    // }
  },
}